// src/pages/CheckoutContext.js
import React, { createContext, useContext, useState } from "react";

const CheckoutContext = createContext();

export const CheckoutProvider = ({ children }) => {
  const [checkoutData, setCheckoutData] = useState({
    shipping: {
      name: "",
      address: "",
      zip: "",
      city: "",
      country: "",
    },
    payment: {
      cardNumber: "",
      expiry: "",
      cvc: "",
    },
    // Evt. mer data
  });

  return (
    <CheckoutContext.Provider value={{ checkoutData, setCheckoutData }}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => useContext(CheckoutContext);